<template>
  <div class="plc" id="Privacy">
    <div class="top-title">GamAI Policies</div>
    <p class="title" name="Contact">Privacy Policy</p>
    <div class="main">
      <div v-html="policyContent"></div>
    </div>
  </div>
</template>
<script>
import policyContent from "@/constants/policy.html";
export default {
  name: "Policies",
  mounted() {
    this.toTop();
  },
  methods: {
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
  data: function () {
    return {
      formItem: {
        name: '',
        type: '',
        email: '',
        message: ''
      },
      policyContent
    }
  }
};
</script>
<style>

</style>
<style lang="scss" scoped>
.plc {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  .top-title {
    background: $--color-primary;
    height: px2rem(200);
    line-height: px2rem(200);
    color: #fff;
    margin-top: px2rem(60);
    font-size: px2rem(60);
    font-weight: bolder;
  }
  .title {
    margin-top: px2rem(100);
  }
  .main {
    max-width: px2rem(900);
    margin: 50px auto 0 auto;
    padding-bottom: px2rem(40);
    text-align: left;
  }
}
</style>